export default {
  apiDomain: "http://localhost:5000/api/",
  //apiDomain: "https://quiet-hamlet-94505.herokuapp.com/",
  dbConn: ""
};
